import {installMethodEnum, signalGradeEnum} from 'utils/const/globalConst'

interface toolTipsType {
  description: String
  text: React.ReactNode
}

interface toolTipTextType {
  customerRegister: toolTipsType
  customerAllocation: toolTipsType
  customerInfo: toolTipsType
  customerBinaryCheck: toolTipsType
  customerFlaggedReview: toolTipsType
  customerActivity: toolTipsType
  customerCheckList: toolTipsType
  customerCheckReport: toolTipsType
  customerMinimumFlow: toolTipsType
  customerStatus: toolTipsType
  customerhdm: toolTipsType
  customerLeakage: toolTipsType
  deviceRegister: toolTipsType
  deviceAllocation: toolTipsType
  deviceInfo: toolTipsType
  deviceImages: toolTipsType
  deviceHistory: toolTipsType
  asManagement: toolTipsType
  recoveryInfo: toolTipsType
  account: toolTipsType
  customerUnused: toolTipsType
  customerFreezeWarning: toolTipsType
  dashboardFreezeWarning: toolTipsType
  customerPhoto: toolTipsType
}

// 확인 필요 수용가 툴팁: 유형별 색상 점 + 설명 한 줄 (칩 색상과 동일하게 색으로 구분)
const FlaggedIssueLine = ({color, name, desc}: {color: string; name: string; desc: string}) => (
  <span className={'text-lg'} style={{display: 'flex', alignItems: 'flex-start'}}>
    <span
      style={{
        display: 'inline-block',
        width: 11,
        height: 11,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: 8,
        marginTop: 6,
        flexShrink: 0,
      }}
    />
    <span>
      <b>{name}</b> : {desc}
    </span>
  </span>
)

export const toolTipText: toolTipTextType = {
  customerRegister: {
    description: '수용가 등록을 진행합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>수용가 등록</span>
        <span className={'fs-5'}>● 개별등록과 일괄등록을 진행 할 수 있습니다.</span>
        <span className={'fs-5'}>
          ● 주소 검색을 통해 도로명 주소와 지번 주소를 입력 할 수 있습니다.
        </span>
        <span className={'fs-5'}>● 담당자를 입력하여 모니터링 할 수 있습니다.</span>
        <span className={'fs-5'}>● 특이사항이 있는 수용가에 메모를 입력 할 수 있습니다.</span>
      </div>
    ),
  },
  customerAllocation: {
    description: '수용가를 할당합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>수용가 할당</span>
        <span className={'fs-5'}>● 설치 가능한 수용가에 대한 할당을 관리합니다.</span>
        <span className={'fs-5'}>● 할당된 수용가에 대해 추가, 취소할 수 있습니다.</span>
        <span className={'fs-5'}>● 할당및 설치 가능 여부에 따라 수용자를 검색할 수 있습니다.</span>
        <span className={'fs-5'}>● 필요에 따라 수용가의 할당을 삭제 할 수 있습니다.</span>
      </div>
    ),
  },
  customerInfo: {
    description: '수용가의 정보를 조회합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>수용가 정보 관리</span>
        <span className={'fs-5'}>● 수용가의 정보를 확인, 관리 가능합니다.</span>
        <span className={'fs-5'}>
          ● 연결된 단말기의 정보를 포함, 수용가의 데이터를 열람할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 검색항목을 기준으로 수용가를 필요한 정보를 빠르게 찾을 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● A/S 등록 및 취소 기능으로 수용가에 대한 서비스 관리를 용이하게 합니다.
        </span>
        <span className={'fs-5'}>● 수용가 정보를 엑셀 파일로 내려 받는 기능을 제공합니다.</span>
      </div>
    ),
  },
  customerBinaryCheck: {
    description: '검침 이미지의 유효성을 확인합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3'}>검침 이미지 검증</span>
        <span className={'text-lg'}>
          ● 해당 단말기가 정상적으로 검침한 이미지를 전송 하는지 아닌지 비교 합니다.
        </span>
        <span className={'text-lg'}>
          ● 시작 날짜의 '첫번째' 이미지와 마지막 날짜의 '마지막' 이미지를 검증합니다.
        </span>
        <span className={'text-lg'}>
          ● 검침값이 동일해도, 물리적으로 다른 이미지 인 경우는 다른 이미지입니다.
        </span>
        <span className={'text-lg'}>
          ● 조건 검색 '이미지 검증 상태'의 경우 데이터 추가중에 있어 제대로 동작하지 않을 가능성이
          있습니다.
        </span>
      </div>
    ),
  },

  customerFlaggedReview: {
    description: '확인 검토 필요한 수용가를 조회 합니다.',
    text: (
      <div className={'row gap-3 p-2'} style={{width: 600, maxWidth: '100%'}}>
        <span className={'fs-3'}>확인 필요 수용가</span>
        <span className={'text-lg'}>
          ● 시작 날짜와 마지막 날짜를 기준으로 확인이 필요한 수용가를 조회합니다.
        </span>
        <span className={'text-lg'}>
          ● 확인이 필요한 유형은 총 9가지이며, 아래 칩(태그)을 눌러 유형별로 조회할 수 있습니다.
        </span>

        <span className={'text-lg fw-bold'} style={{opacity: 0.8}}>
          [이미지 판독 관련]
        </span>
        <FlaggedIssueLine
          color='#8b5cf6'
          name='동일 이미지'
          desc='이전 이미지와 마지막 이미지가 완전히 동일한 파일로, 단말기가 새로운 촬영 없이 이전 이미지를 전송한 상태입니다.'
        />
        <FlaggedIssueLine
          color='#ef4444'
          name='인식 실패'
          desc='숫자 인식을 진행하였으나, 인식에 실패하여 검침값 확인이 불가한 이미지입니다.'
        />
        <FlaggedIssueLine
          color='#eab308'
          name='자릿수 오류'
          desc='인식된 검침값의 자릿수가 저장된 계량기 자릿수와 일치하지 않아 확인이 필요한 이미지입니다.'
        />
        <FlaggedIssueLine
          color='#06b6d4'
          name='검침값 확인 필요'
          desc='숫자는 인식되었으나 일부 자릿수의 인식 정확도가 낮아, 실제 검침값과 다를 수 있는 이미지입니다.'
        />
        <FlaggedIssueLine
          color='#ea580c'
          name='비정상 사용량'
          desc='이전 검침값과 다음 검침값을 비교한 사용량이 정상 범위를 벗어나(증가·감소 모두 해당) 확인이 필요한 이미지입니다.'
        />
        <FlaggedIssueLine
          color='#64748b'
          name='이미지 에러'
          desc='이미지 촬영·저장 과정의 문제로 정상적인 판독이 어려운 이미지입니다.'
        />

        <span className={'text-lg fw-bold'} style={{opacity: 0.8}}>
          [단말기·통신 관련]
        </span>
        <FlaggedIssueLine
          color='#84cc16'
          name='베터리 확인 필요'
          desc='단말기 배터리 잔량이 낮아 점검이 필요한 상태입니다.'
        />
        <FlaggedIssueLine
          color='#0ea5e9'
          name='단말기 통신 불량'
          desc='단말기 통신이 원활하지 않은 상태입니다.'
        />
        <FlaggedIssueLine
          color='#6366f1'
          name='검침기 통신 불량'
          desc='검침기와 단말기 사이 통신이 원활하지 않은 상태입니다.'
        />
      </div>
    ),
  },

  customerActivity: {
    description: '지속적인 모니터링으로 사회복지 서비스를 제공합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>건강 모니터링</span>
        <span className={'fs-5'}>
          ● 수용가 종류를 '노인'으로 설정한 데이터에 대한 정보를 제공합니다.
        </span>
        <span className={'fs-5'}>
          ● 독거 노인들의 생활 패턴을 자원 사용량을 모니터링하여 그들의 안전,복지를 확인합니다.
        </span>
        <span className={'fs-5'}>
          ● 일관되거나 지속적인 자원 사용 패턴이 감지 될 경우, 해당 수용가의 위험 상태를 암시할 수
          있으며, 적절한 조치를 취할 수 있도록 경고합니다.
        </span>
        <span className={'fs-5'}>
          ● 사용량 데이터는 시각적으로 명확한 그래프 형태로 표시됩니다.
        </span>
        <span className={'fs-5'}>
          ● 날짜별로 데이터를 검색 하여, 특정 시기의 사용량 변화를 분석 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 이 페이지는 독거노인들의 건강과 안전을 지키는 데 중요한 역할을 하며, 지역 사회의
          보호망을 강화하는 데 기여합니다.
        </span>
      </div>
    ),
  },
  customerCheckList: {
    description: '수용가의 검침내역을 기간 별로 조회 할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>수용가 검침조회</span>
        <span className={'fs-5'}>
          ● 기간별 검침 이미지 확인 및 검침 간의 사용량을 조회 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 특정 기간 동안의 검침 이미지를 열람하여, 수용가의 검침 상태를 시각적으로 확인
          가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 전 검침값부터 다음 검침값까지의 총 사용량을 확인할 수 있어, 수용가별 소비 패턴을 분석,
          관리에 유용합니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 수용가의 에너지 사용 효율성을 평가하고, 필요한 경우 조정을 위한 근거를 제공받을
          수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 에너지 관리와 소비 효율성 향상에 중요한 역할을 하는 도구로, 정확한 검침 데이터의 확인과
          분석을 용이하게 합니다.
        </span>
      </div>
    ),
  },
  customerCheckReport: {
    description: '전체 수용가의 검침일에 맞는 리포트를 확인할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>검침 리포트</span>
        <span className={'fs-5'}>● 검침일에 해당하는 검침값을 확인하고 관리할 수 있습니다.</span>
        <span className={'fs-5'}>
          ● 사용자가 전월 및 당월 검침값을 직접 확인하고 필요에 따라 수정할 수 있는 기능을
          제공합니다.
        </span>
        <span className={'fs-5'}>
          ● 검침 데이터의 정확성을 보장하고, 필요시 즉각적인 조정을 가능하게 합니다.
        </span>
        <span className={'fs-5'}>
          ● 특히, 당월 검침일이 아직 도래하지 않아 검침 이미지가 없는 경우,
          <span className={'text-danger'}>'검침 데이터 수집 중입니다.'</span>으로 명확히 표시됩니다.
        </span>
        <span className={'fs-5'}>
          ● 검침 데이터의 정확성과, 시의성을 확보하여 사용자가 현재 검침 상태를 쉽게 이해할 수
          있도록 돕습니다.
        </span>
      </div>
    ),
  },
  customerMinimumFlow: {
    description: '설정한 시간에 사용량이 있는 수용가 정보를 조회합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>최소유량 조회</span>
        <span className={'fs-5'}>
          ● 주로 야간 시간대에 누수 발생 여부를 탐지하는 데 중점을 두고 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 특정 시간대의 데이터를 확인하여, 물 사용 패턴을 분석, 이상 유량을 식별할 수
          있습니다.
        </span>
        <span className={'fs-5'}>
          ● 주로 야간에 발생할 수 있는 누수를 조기에 발견, 대응하는 데 큰 도움이 됩니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 원하는 시간대를 선택하여 해당 기간 동안의 사용량 및 검침 데이터를 상세히 조회할
          수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● <span className={'fw-bold fs-4'}>'사용량 존재여부'</span> 스위치를 이용하여 사용량이
          실제로 존재하는 수용가들의 데이터만 필터링 하여, 보다 효율적인 데이터 관리가 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 수용가의 물 사용 패턴을 모니터링, 필요한 조치를 취하기 위한 중요한 정보를 제공합니다.
        </span>
      </div>
    ),
  },
  customerStatus: {
    description: '수용가 현황을 조회합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>수용가 현황</span>
        <span className={'fs-5'}>
          ● 수용가 번호를 클릭하여 해당 수용가의 상세 정보를 열람할 수 있으며, 필요한 경우 기본적인
          정보를 수정할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 검침 이미지의 기록들을 통해, 수용가의 검침 데이터를 시각적으로 확인할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 이미지 클릭시, 표 형식으로 제공되는 단말기의 배터리 정보,온도 등의 상세 데이터를 확인할
          수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 이 페이지는 관리자들이 수용가의 상태를 효과적으로 관리하고, 필요한 정보를 신속하게
          접근할 수 있도록 설계되었습니다.
        </span>
      </div>
    ),
  },
  customerhdm: {
    description: 'HDM 수용가 현황을 조회합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>HDM 수용가 현황</span>
        <span className={'fs-5'}>
          ● 수용가 번호를 클릭하여 해당 수용가의 상세 정보를 열람할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 검침 이미지의 기록들을 통해, 수용가의 검침 데이터를 시각적으로 확인할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 이미지 클릭시, 표 형식으로 제공되는 단말기의 배터리 정보,온도 등의 상세 데이터를 확인할
          수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 이 페이지는 관리자들이 수용가의 상태를 효과적으로 관리하고, 필요한 정보를 신속하게
          접근할 수 있도록 설계되었습니다.
        </span>
      </div>
    ),
  },
  customerLeakage: {
    description: '누수가 의심되는 수용가의 정보를 조회합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>누수의심 조회</span>
        <span className={'fs-5'}>
          ● 날짜를 선택하여 누수가 의심되는 수용가의 사용량을 확인 할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 해당 날짜를 기준으로 설정된 주기 전의 측정된 사용량과 해당 날짜의 측정된 사용량으로
          누수의심 측정값를 예측하며, 예측된 누수의심 측정값보다 측정된 사용량이 많은 수용가를 조회
          합니다.
        </span>
        <span className={'fs-5'}>
          ● 이 페이지를 통해 예측 사용량과 실제 사용량의 큰 차이가 나는 수용가를 조회하여 필요한
          조치를 취하기 위한 정보를 제공합니다.
        </span>
      </div>
    ),
  },
  deviceRegister: {
    description: '단말기 등록을 진행합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>단말기 등록</span>
        <span className={'fs-5'}>● 개별등록과 일괄등록을 진행 할 수 있습니다.</span>
        <span className={'fs-5'}>
          ● 해당하는 단말기 타입이 없는 겅우 우측의 단말기 타입 버튼 추가를 통해 추가 가능합니다.
        </span>
        <span className={'fs-5'}>● 월 별로 추가된 단말기의 등록 현황을 확인 가능합니다.</span>
      </div>
    ),
  },
  deviceAllocation: {
    description: '단말기의 검수 및 할당을 조회 할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>검수/할당 관리</span>
        <span className={'fs-5'}>
          ● 검수 조회 페이지에서 단말기 등록 후 해당 단말기가 송신한 이미지를 통해 승인 상태를
          관리합니다.
        </span>
        <span className={'fs-5'}>
          ● 검색 항목 필터링을 통해 특정한 단말기의 정보를 확인 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● <span className={'text-primary'}>'IMEI'</span>행을 클릭 시, 해당 단말기의 상세 정보를
          확인 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 할당 조회 페이지에서 검수 완료된 단말기를 설치자에게 할당 가능합니다.
        </span>
      </div>
    ),
  },
  deviceInfo: {
    description: '미터리움(METERARIUM) 단말기 정보를 보여줍니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>단말기 정보 관리</span>
        <span className={'fs-5'}>● 단말기의 상세 정보를 중심적으로 다룹니다.</span>
        <span className={'fs-5'}>
          ● 사용자는 단말기의 이미지 히스토리를 비롯해 중요한 기술적 세부사항을 확인할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 특히 단말기의 전파 세기, 최초 등록일자, 단말기 펌웨어 및 검침기 펌웨어 정보 등이 명시
          되어 사용자가 쉽게 접근 및 분석이 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 단말기의 성능 및 상태를 효과적으로 제공하고 모니터링에 필요한 모든 정보를 제공함으로써,
          시스템의 안정성, 효율성을 지속적으로 유지 가능하게 합니다.
        </span>
      </div>
    ),
  },
  deviceImages: {
    description: '단말기에서 수신하는 이미지를 조회할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>단말기 수신영상 관리</span>
        <span className={'fs-5'}>
          ● 미터리움 시스템에 수신되는 모든 단말기의 정보를 조회하고 관리합니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 '정상처리', '인식 실패', '자리수 인식 오류', '인식 대기 중', '비정상 이미지',
          '검침값이 수정된 이미지'등의 카테고리별로 분류된 단말기 검침 결과를 열람할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ●사용자는 각 단말기의 현재 상태, 검침 데이터의 정확성을 파악할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 기간별로 수신된 이미지를 조회하는 기능을 제공하며, 단말기 활동과 상태 변화를 분석할 수
          있습니다.
        </span>
        <span className={'fs-5'}>
          ● 미터리움 시스템의 효과적인 모니터링과 관리에 필수적인 도구로, 데이터의 정확성과,
          시스템의 신뢰성을 유지하는데 중요한 역할을 합니다.
        </span>
      </div>
    ),
  },
  deviceHistory: {
    description: '단말기의 모든 기록들을 확인할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>단말기 History</span>
        <span className={'fs-5'}>● 미터리움에 등록된 모든 단말기의 기록을 확인 가능합니다. </span>
        <span className={'fs-5'}>
          ● 각 단말기 별 단말기 버전, 서버로 데이터 전송 주기, 전파 강도등을 확인 가능합니다.
        </span>
      </div>
    ),
  },
  asManagement: {
    description: 'A/S 조회 및 등록을 할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>A/S 관리</span>
        <span className={'fs-5'}>● 서비스 요청에 대한 A/S 작업을 관리, 조정 합니다.</span>
        <span className={'fs-5'}>
          ● A/S 작업을 새로 배정하거나 기존 배정을 취소하는 기능을 제공합니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 원인명, 해결명, 결과, 그리고 A/S 할당 상태와 같은 다양한 기준에 따라 A/S 요청을
          조회할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 사용자는 서비스 요청의 상태를 신속히 파악하고, 필요에 따라 적절한 A/S 작업을 할당하거나
          변경할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 서비스 요청의 효율적인 처리와 고객 만족도 향상을 위한 중요한 도구로서, 서비스 품질
          관리에 핵심적인 역할을 합니다.
        </span>
      </div>
    ),
  },
  recoveryInfo: {
    description: '단말기의 회수 상태를 조회 할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>회수 조회</span>
        <span className={'fs-5'}>
          ● 설치된 단말기들을 회수하여 검수 및 재생 과정을 진행하는 페이지입니다.
        </span>
        <span className={'fs-5'}>
          ● 현장에서 사용되고 있는 단말기들의 회수 상태를 추적하고 관리하는 데 중점을 두고 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 회수된 단말기들의 목록을 확인할 수 있으며, 각 단말기의 현재 상태와 검수 진행 상황을
          상세히 파악할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 단말기가 효율적으로 재생, 재사용 전 필요한 검수 작업이 적절히 이루어지고 있는지
          모니터링할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 단말기의 수명 주기 관리와 자원의 효율적 사용을 지원하며, 지속 가능한 운영 관행을
          촉직하는 역할을 합니다.
        </span>
      </div>
    ),
  },
  account: {
    description: '사용자 등록과 그룹관리를 할 수 있습니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>사용자 계정 관리</span>
        <span className={'fs-5'}>● 회원 가입한 모든 계정의 관리가 가능합니다.</span>
        <span className={'fs-5'}>
          ● 관리자는 사용자들의 계정을 수정하거나 이미지 URL을 업데이트할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 새로운 계정을 생성하고 계정 타입을 추가, 삭제, 수정등의 작업을 진행 가능합니다.
        </span>
        <span className={'fs-5'}>
          ● 검색 기능을 통해 권한과 활성화 상태를 기준으로 특정 사용자를 빠르고 쉽게 찾아볼 수
          있습니다.
        </span>
        <span className={'fs-5'}>
          ● 시스탬 내에서 다양한 역할과 책임을 가진 사용자들을 효과적으로 관리하기 위한 중심적인
          도구로 가능합니다.
        </span>
      </div>
    ),
  },
  customerUnused: {
    description: '장기미사용중인 수용가를 조회 합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>장기미사용</span>
        <span className={'fs-5'}>● 검침값이 일정 기간동안 동일한 수용가를 조회힙니다.</span>
        <span className={'fs-5'}>
          ● 관리자는 사업소 기초설정 페이지에서 해당 기간을 수정 할 수 있습니다.
        </span>
        <span className={'fs-5'}>
          ● 장기미사용 조회 페이지를 통해 장시간미사용인 수용가에 대한 조치를 취할 수 있습니다.
        </span>
      </div>
    ),
  },
  customerFreezeWarning: {
    description: '동파위험이 있는 수용가를 조회 합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>동파위험 조회</span>
        <span className={'fs-5'}>
          ● 계량기내 설치되는 온도센서를 통해 온도를 측정하고 조회 합니다.
        </span>
        <span className={'fs-5'}>
          ● -1°C 초과 (양호), -1°C ~ -3°C (주의), -3°C ~ -5°C (위험), -5°C미만 (매우위험) 4단계로
          구분 합니다.
        </span>
        <span className={'fs-5'}>
          ● 정확한 온도 모니터링으로 동절기 계량기 동파를 사전 방지 하며, 동파 이후 발생되는 계량기
          교체, 및 행정적인 비용, 물 사용자 민원에 대한 선제적 대응조치를 취할 수 있습니다.
        </span>
      </div>
    ),
  },
  dashboardFreezeWarning: {
    description: '동파위험이 있는 수용가를 조회 합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-5'}>
          ● -1°C 초과 (양호), -1°C ~ -3°C (주의), -3°C ~ -5°C (위험), -5°C미만 (매우위험) 4단계로
          구분 합니다.
        </span>
      </div>
    ),
  },

  customerPhoto: {
    description: '설치, A/S 시점의 작업 사진을 확인 합니다.',
    text: (
      <div className={'row gap-3 p-2'}>
        <span className={'fs-3 fw-bold'}>사진첩 조회</span>
        <span className={'fs-5'}>● 설치, A/S 시점의 작업 사진을 확인 합니다.</span>
        <span className={'fs-5'}>
          ● 이미지 클릭 시 해당 수용가의 환경, 계량기, 검침기 사진등을 확인 가능합니다.
        </span>
        <span className={'fs-5'}>● 필요시 다운로드 기능을 통하여 사진첩을 받으실 수 있습니다.</span>
      </div>
    ),
  },
}

/**
 * 신호 등급(RSRP x RSRQ 판정)과 설치자가 선택한 설치 방식을 조합한 설치 안내.
 *
 * 조치는 `내부 설치 -> 외부 설치 -> 담당자 연락` 순으로 단계가 올라간다.
 * 즉 내부에 설치한 상태에서 신호가 나쁘면 먼저 외부로 빼보도록 안내하고,
 * 이미 외부인데도 '확인필요'면 더 이상 현장에서 개선할 수단이 없으므로 연락을 안내한다.
 *
 * | 등급     | 내부설치            | 외부설치    |
 * |----------|---------------------|-------------|
 * | 양호     | 진행 가능           | 진행 가능   |
 * | 보통     | 외부로 빼서 재확인  | 진행 가능   |
 * | 확인필요 | 외부로 빼서 재확인  | 담당자 연락 |
 *
 * @param grade       측정 신호 등급. null 이면 아직 수신 전이라 안내하지 않는다.
 * @param installType 설치자가 선택한 설치 방식. 미선택이면 상태만 알리고 조치는 생략한다.
 */
export const installDevicedBmToolTip = (
  grade: signalGradeEnum | null,
  installType?: installMethodEnum | null
) => {
  if (grade == null) {
    /* 전파 세기·품질을 아직 수신하지 못한 상태 */
    return <></>
  }

  if (grade === signalGradeEnum.GOOD) {
    return (
      <div className={'fw-bold fs-4 px-3 gap-3'}>
        <div className={'fw-bold alert alert-success text-center row'}>
          <span>전파 환경이 양호하여 설치를 진행하셔도 됩니다.</span>
          <span>주변에 전파방해 요소가 있을 시 외부 설치로 진행해주세요.</span>
        </div>
      </div>
    )
  }

  const isNeedCheck = grade === signalGradeEnum.NEED_CHECK

  /* 내부에 설치한 상태라면 등급과 무관하게 먼저 외부 설치를 권한다 */
  const action =
    installType === installMethodEnum.INSIDE ? (
      <div className={'fw-bold alert alert-dark text-center row'}>
        <span>외부로 빼서 설치한 뒤</span>
        <span>전파 상태를 다시 확인해주세요.</span>
      </div>
    ) : installType === installMethodEnum.OUTSIDE ? (
      isNeedCheck ? (
        <div className={'fw-bold alert alert-dark text-center row'}>
          <span>담당자에게 연락하여</span>
          <span>설치 여부를 확인해주세요.</span>
        </div>
      ) : (
        /* 외부까지 뺀 상태의 '보통'은 현장 조치 없이 그대로 진행한다 */
        <div className={'fw-bold alert alert-success text-center row'}>
          <span>외부 설치 상태이므로</span>
          <span>그대로 설치를 진행해주세요.</span>
        </div>
      )
    ) : null

  return (
    <div className={'fs-4 px-3 gap-3'}>
      <div className={`fw-bold alert text-center row ${isNeedCheck ? 'alert-danger' : 'alert-warning'}`}>
        {isNeedCheck ? (
          <span>전파 환경이 불량하여 확인이 필요합니다.</span>
        ) : (
          <span>전파 환경이 보통입니다.</span>
        )}
        <span>검침값 전송에 문제가 생길 수 있습니다.</span>
      </div>
      {action}
    </div>
  )
}

export const DeviceEditImageTooltip = (type: any) => {
  switch (type) {
    case 'original':
      return (
        <div className={'row gap-3 p-2'}>
          <span className={'fs-5'}>1. 레이어 설정을 통해 색, 굵기를 설정해주세요.</span>
          <span className={'fs-5'}>
            2. 원본 이미지에 숫자 영역을 제외한 빛 번짐으로 예상되는 구역을 칠해주세요.
          </span>
        </div>
      )
    case 'overLay':
      return (
        <div className={'row gap-3 p-2'}>
          <span className={'fs-5'}>
            1. 원본 이미지에 칠한 색이 표현되며, 직접 칠은 불가능합니다.
          </span>
          <span className={'fs-5'}>2. 저장 시 해당 레이어만 저장됩니다.</span>
          <span className={'fs-5'}>3. 원본 이미지를 변경하지 않습니다.</span>
        </div>
      )

    case 'filter':
      return (
        <div className={'row gap-3 p-2'}>
          <span className={'fs-5'}>1. 필터 설정 값을 변경해주세요</span>
          <span className={'fs-5'}>
            2. 해당 필터 설정을 반영하여 원본이미지에 필터를 적용합니다.
          </span>
          <span className={'fs-5'}>3. 저장 시 해당 필터 설정값만 저장됩니다. </span>
          <span className={'fs-5'}>4. 원본 이미지를 변경하지 않습니다.</span>
        </div>
      )
    case 'final':
      return (
        <div className={'row gap-3 p-2'}>
          <span className={'fs-5'}>1. 레이어와, 필터 이미지를 결합한 이미지입니다.</span>
          <span className={'fs-5'}>
            2. 실제 이미지 인식 시 적용 될 이미지를 예상한 이미지입니다.
          </span>
          <span className={'fs-5'}>
            3. 수용가 정보, 수용가 현황 페이지에서는 필터를 제외한, 이미지를 확인 할 수 있습니다.
          </span>
        </div>
      )
    default:
      return <></>
  }
}
